import React from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Card, Typography } from '@altermaind/web/ui';
import { AnswerResultEnum } from '@/swagger/constants/quiz-enums';

type Props = {
  answerResult: `${AnswerResultEnum}`;
  feedbackText: string;
};

export const AnswerFeedback = ({ answerResult, feedbackText }: Props) => {
  const t = useTranslations('quiz.dynamicQuiz');

  return (
    <Box>
      <Card py={0} px={0} borderRadius='s'>
        <Box>
          <Box flexDirection='row' display='flex' justifyContent='space-between' my='xs'>
            <Typography variant='p1/light'>{t(`answerFeedbackLabels.${answerResult}`)}</Typography>
          </Box>
          <Typography variant='p1/light'>{feedbackText}</Typography>
        </Box>
      </Card>
    </Box>
  );
};
